/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTerapiaCreateDTO
 */
export interface AssistitoTerapiaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    richiedente?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    patologiaMotivante?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTerapiaCreateDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    tipologiaMedicinale?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    posologia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoTerapiaCreateDTO interface.
 */
export function instanceOfAssistitoTerapiaCreateDTO(value: object): value is AssistitoTerapiaCreateDTO {
    return true;
}

export function AssistitoTerapiaCreateDTOFromJSON(json: any): AssistitoTerapiaCreateDTO {
    return AssistitoTerapiaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoTerapiaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTerapiaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'patologiaMotivante': json['patologiaMotivante'] == null ? undefined : json['patologiaMotivante'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'tipologiaMedicinale': json['tipologiaMedicinale'] == null ? undefined : json['tipologiaMedicinale'],
        'posologia': json['posologia'] == null ? undefined : json['posologia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoTerapiaCreateDTOToJSON(value?: AssistitoTerapiaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'richiedente': value['richiedente'],
        'patologiaMotivante': value['patologiaMotivante'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio'] as any).toISOString()),
        'tipologiaMedicinale': value['tipologiaMedicinale'],
        'posologia': value['posologia'],
        'note': value['note'],
    };
}

